<template>
  <div v-loading="showFlag">
    <!-- 画面タイトル -->
    <t-card style="height: calc(89vh - 19px); width: 100%">
      <div class="search">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          label-width="150px"
        >
          <t-row>
            <t-col :span="2">
              <t-button plain type="primary" @click="AddClick">
                <i class="el-icon-plus"></i>
                {{ $t("resource.sys.newBuilt") }}
              </t-button>
            </t-col>
          </t-row>
        </t-form>
      </div>
      <t-row>
        <t-table
          v-tableScrollTop
          class="roleManage"
          :data="tableData"
          style="width: 100%"
          :max-height="maxheight"
          header-cell-class-name="bg-default"
          border
          stripe
          @sort-change="TableSort"
        >
          <t-table-column
            type="index"
            :label="$t('resource.roleManage.tblNo')"
            min-width="5%"
            header-align="left"
            fixed="left"
          >
          </t-table-column>
          <t-table-column
            prop="roleId"
            :label="$t('resource.roleManage.roleID')"
            min-width="20%"
            header-align="left"
            sortable="custom"
          >
          </t-table-column>
          <t-table-column
            prop="roleName"
            :label="$t('resource.roleManage.roleName')"
            header-align="left"
            sortable="custom"
            min-width="20%"
          >
          </t-table-column>
          <t-table-column
            prop="authName"
            :label="$t('resource.roleManage.roleAuths')"
            header-align="left"
            sortable="custom"
            min-width="40%"
          >
          </t-table-column>
          <t-table-column
            prop="enableFlgNm"
            :label="$t('resource.roleManage.enableFlg')"
            header-align="left"
            sortable="custom"
            min-width="10%"
            :resizable="false"
          />
          <t-table-column
            :label="$t('resource.roleManage.operation')"
            min-width="5%"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <a
                href="javascript:void(0)"
                :title="$t('resource.roleManage.edit')"
                tabindex="-1"
                @click="() => Change(scope.row)"
              >
                <em class="el-icon-edit-outline" />
              </a>
            </template>
          </t-table-column>
        </t-table>
        <t-pagination
          align="right"
          :current-page.sync="PageNo"
          :page-size="PageSize"
          :page-sizes="GetPageDataCountFunc()"
          layout="total, sizes, prev, pager, next"
          :total="RecordTotal"
          @current-change="PageChange"
          @size-change="handleSizeChange"
        >
        </t-pagination>
      </t-row>
    </t-card>
  </div>
</template>


<script>
import { ShowRoleDialog } from "@/components/Dialog";
import { t } from "@/locales";
import service from "@/services/roleManage";
import { GetPageDataCount } from "@/utils/const";
import masterService from "@/utils/page";
export default {
  name: "RoleManage",
  data() {
    return {
      maxheight: 688,
      searchConditionForm: {
        searchWord: "",
      },
      // 一览数据
      roleManageData: [],
      // 检索
      search: "",
      // 当前页数
      PageNo: 1,
      // pageTotal: 0,
      // 每页条数
      PageSize: 30,
      showFlag: false,
    };
  },
  computed: {
    tableData() {
      return this.roleManageData
        .filter(
          (data) =>
            !this.search ||
            data.roleId.toLowerCase().includes(this.search.toLowerCase()) ||
            data.roleName.toLowerCase().includes(this.search.toLowerCase()) ||
            data.authName.toLowerCase().includes(this.search.toLowerCase())
        )
        .slice((this.PageNo - 1) * this.PageSize, this.PageNo * this.PageSize);
    },
    RecordTotal() {
      return this.roleManageData.filter(
        (data) =>
          !this.search ||
          data.roleId.toLowerCase().includes(this.search.toLowerCase()) ||
          data.roleName.toLowerCase().includes(this.search.toLowerCase()) ||
          data.authName.toLowerCase().includes(this.search.toLowerCase())
      ).length;
    },
  },
  mounted() {
    // 设置表格高度
    this.$nextTick(() => {
      this.maxheight = document.body.clientHeight - 248;
    });

    this.Init();
  },
  methods: {
    // 初期化
    Init() {
      this.showFlag = true;
      service
        .InitSearch()
        .then((res) => {
          this.roleManageData = res;
          this.showFlag = false;
        })
        .catch(() => {
          this.showFlag = false;
        });
    },
    // 翻页处理
    PageChange(val) {
      this.PageNo = val;
    },
    // 每页条数
    handleSizeChange(val) {
      this.PageNo = 1;
      this.PageSize = val;
    },
    // 新規
    AddClick() {
      ShowRoleDialog(
        {
          isAdd: true,
        },
        t("resource.roleManage.roleCreateView"),
        this.Init
      );
    },
    // 変更
    Change(row) {
      ShowRoleDialog(
        {
          roleId: row.roleId,
          isAdd: false,
        },
        t("resource.roleManage.roleEditView"),
        this.Init
      );
    },
    // 每页数据条数
    GetPageDataCountFunc() {
      return GetPageDataCount();
    },
    TableSort(column) {
      this.pageNo = 1; // 排序后返回第一页
      masterService.TableSort(this.roleManageData, column);
    },
  },
};
</script>
@/utils/masterManage
